import { defineMessages } from 'react-intl';

const _default_1: {
	noOptionsMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	searchPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	noOptionsMessage: {
		id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
		defaultMessage: 'No matches found',
		description: 'The text for when no matches are found in dropdown',
	},
	searchPlaceholder: {
		id: 'paginated-picker.async-select.select.search-placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder text in search input indicating that the user can search',
	},
});
export default _default_1;
